/*
 * Jira Ticket:
 * Created Date: Thu, 9th Jul 2020, 16:22:59 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
import React, { Fragment } from 'react';
import { Link, Typography } from '@material-ui/core';

const InformationModalContent = ({ approvalUrl, classes, translate }) => {
  return (
    <Fragment>
      <Typography color="primary" variant="h5">
        {translate('resources.SubscriptionTier.fields.informationModalTitle')}
      </Typography>
      <p>
        {translate(
          'resources.SubscriptionTier.fields.informationModalContent1'
        )}
      </p>
      <p>
        {translate(
          'resources.SubscriptionTier.fields.informationModalContent2'
        )}
        <Link
          href="https://pasma.co.uk/about/contact/"
          color="secondary"
          className={classes.redirectionLink}
          target="_blank"
        >
          {translate(
            'resources.SubscriptionTier.fields.informationModalContent3'
          )}
        </Link>
      </p>
    </Fragment>
  );
};

export default InformationModalContent;
